import { render, staticRenderFns } from "./CalculatorSms.vue?vue&type=template&id=1b0a71f1&scoped=true&"
import script from "./CalculatorSms.vue?vue&type=script&lang=js&"
export * from "./CalculatorSms.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorSms.vue?vue&type=style&index=0&id=1b0a71f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a71f1",
  null
  
)

component.options.__file = "CalculatorSms.vue"
export default component.exports